import Vue from 'vue'
import config from 'config'
import getIquoteIdQuery from '../../graphql/b2b/getIQuoteId'

export default {
  state: {
    b2bIsAuthenticated: false,

  },
  getters: {
    b2bIsAuthenticated: (state) => state.b2bIsAuthenticated,
  },
  mutations: {
    SET_IS_AUTHENTICATED(state, boolean) {
      state.b2bIsAuthenticated = boolean
    },
  },
  actions: {
    async getIquoteId(context, payload) {
      const body = {
        query: getIquoteIdQuery(payload.postalCode, payload.loginKey)
      }
      const { url, key } = config.graphQl
      try {
        const response = await Vue.$http.post(url, body, { headers: { 'api-key': key }})
        console.log('test response', response)
        
        const data = response.data
        
        if (!data || !data.data || data.errors) {
          return {
            error: data.errors ? data.errors[0].message : 'NO DATA'
          }
        }
        else if (data.data.login || data.data.login.accessToken) {
          context.commit('SET_IS_AUTHENTICATED', true)
          context.commit('SET_IQUOTE_ID', data.data.login.accessToken, { root: true })
          return {
            data: data.data
          }
        } 
        else {
          throw new Error('NO CREDENTIALS')
        }
  
      } catch(e) {
        return {
          error: e.message
        }   
      }
    },

  },
}
